import { PaginationMetadata, TableDataSource } from "@/shared/components/table/table.model";
import { UserElementsFragment, UserElementsGQL } from "@/core/graphql/graphql";
import { PaginatorComponent } from "@/shared/components/table/components/paginator/paginator.component";
import { SearchbarComponent } from "@/shared/components/table/components/searchbar/searchbar.component";
import { MatSort } from "@angular/material/sort";
import { FilterComponent } from "@/shared/components/table/components/filter/filter.component";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import {
  CheckboxFilterComponent,
} from "@/shared/components/table/components/checkbox-filter/checkbox-filter.component";
import { CollectionViewer } from "@angular/cdk/collections";
import { tap } from "rxjs/operators";

const DEFAULT_PAGINATION_FACTORY = () => ({
  previousCursors: [],
  currentCursor: null,
  nextCursor: null,
  pageSize: 10,
  count: null,
});

export class UserElementsDatasource extends TableDataSource<UserElementsFragment> {
  public searchbar: SearchbarComponent;
  public sort: MatSort;
  public filter: FilterComponent;
  public readonly _loading$: Observable<boolean>;
  protected _paginator: PaginatorComponent;
  private _currentPagination: PaginationMetadata = DEFAULT_PAGINATION_FACTORY();
  private _elementsSubject = new BehaviorSubject<UserElementsFragment[]>([]);
  private readonly _loadingSubject = new BehaviorSubject<boolean>(true);
  private readonly _paginationMetaSubject = new BehaviorSubject<PaginationMetadata>(this._currentPagination);
  private readonly _dataChangedSubject = new Subject<void>();

  public constructor(
    private readonly _userElementsGql: UserElementsGQL,
    private readonly _userId: number,
  ) {
    super();
    this._loading$ = this._loadingSubject.asObservable();
    this.dataChanged$ = this._dataChangedSubject.asObservable();
  }

  public loadData(currentPageCursor: string | null | undefined): void {
    this._loadingSubject.next(true);
    this._userElementsGql.fetch({
      filters: {
        userId: this._userId,
      },
      meta: {
        pageSize: this._currentPagination.pageSize,
        pageCursor: currentPageCursor,
      },
    }).subscribe((x) => {
      this._elementsSubject.next(x.data.elements.items);
      this._currentPagination.nextCursor = x.data.elements.meta.nextPageCursor;
      this._currentPagination.count = x.data.elements.meta.count;
      this._paginationMetaSubject.next(this._currentPagination);
      this._loadingSubject.next(false);
    });
  }

  public set checkboxFilter(component: CheckboxFilterComponent) {
  }

  public connect(collectionViewer: CollectionViewer): Observable<UserElementsFragment[]> {
    return this._elementsSubject.asObservable().pipe(
      tap(_ => this._dataChangedSubject.next()),
    );
  }

  public disconnect(collectionViewer: CollectionViewer): void {
    this._elementsSubject.complete();
  }

  public set paginator(component: PaginatorComponent) {
    this._paginator = component;
    this._paginator.fetchedPageCursor$.subscribe(this.loadData.bind(this));
    this._paginator.getDatasourceMetaData(this._paginationMetaSubject);
  }
}
